import { Stack, Typography } from '@mui/material';
import type { StyleObj } from '../../@types';
import type { BetBuilderMyBetsGroup } from '../../types/betBuilder';
import { useBetBuilderItem } from '../../hooks/useBetBuilderItem';
import useLocalization from '../../hooks/useLocalization';
import BetBuilderLegList from './BetBuilderLegList';
import OddsDisplay from '../atoms/OddsDisplay';

import { mergeSx } from '../../utils/styles';

const styles: StyleObj = {
  container: {
    flexDirection: 'column',
    gap: 0.5,
    p: 1.5,
    borderTop: '1px solid',
    borderColor: 'neutral.200',
  },
  content: {
    flex: 1,
    minWidth: 0,
    gap: 0.5,
  },
  header: {
    minWidth: 0,
  },
};

type ReofferedBetBuilderItemProps = {
  group: BetBuilderMyBetsGroup;
};

const ReofferedBetBuilderItem = ({ group }: ReofferedBetBuilderItemProps) => {
  const { legs } = useBetBuilderItem({ type: 'myBets', group });
  const { t } = useLocalization();

  return (
    <Stack sx={styles.container} data-testid={`reoffered-bet-builder-item-${group.id}`}>
      <Stack sx={styles.content}>
        <Stack
          direction='row'
          spacing={1}
          sx={mergeSx(
            {
              justifyContent: 'space-between',
            },
            styles.header
          )}
        >
          <Stack
            sx={{
              minWidth: 0,
              textAlign: 'left',
            }}
          >
            <Typography
              variant='subtitle2'
              sx={{
                color: 'neutral.800',
              }}
            >
              {group.event?.name}
            </Typography>
            <Typography
              variant='body2'
              sx={{
                color: 'neutral.600',
              }}
            >
              {t('betBuilder')}
            </Typography>
          </Stack>
          <OddsDisplay
            value={group.odds}
            variant='body2'
            sx={{
              color: 'neutral.800',
              py: 0.5,
              px: 1,
              height: 'fit-content',
            }}
          />
        </Stack>

        <BetBuilderLegList legs={legs} variant='gola' />
      </Stack>
    </Stack>
  );
};

export default ReofferedBetBuilderItem;
